export default {
  auth: {
    back: 'Voltar para o login',
    email: {
      title: 'Entrar',
      subtitle: 'Que tal embarcar nessa viagem agora?',
      placeholder: {
        email: 'Digite o email da sua conta do PlayKids',
        password: 'Digite sua senha'
      },
      forgotPassword: 'Esqueceu a senha? Clique aqui',
      signIn: 'Entrar',
      signInMethodsSeparator: 'Ou',
      playphoneRouter: 'Conectar com Playphone',
      note: 'Login com telefone: Serviço disponível apenas através do aplicativo instalado no seu dispositivo móvel. Acesse o link que enviamos por SMS.',
      signUp: {
        message: 'Não tem uma conta?',
        CTA: 'Cadastrar-se ou resgate via parceiro'
      },
      error: {
        email: 'Digite um email válido.',
        password: 'Digite uma senha válida.',
        invalidRequest: 'Tem algo errado com os dados fornecidos.',
        wrongCredentials:
          'Email não cadastrado ou senha incorreta.\nPor favor, tente novamente.',
        generic: 'Algum erro aconteceu.'
      }
    },
    phone: {
      routerCta: 'Entrar com número de telefone',
      title: 'Entrar com telefone',
      subtitle:
        'Digite seu número com código do país. Se sua operadora exigir PIN, pediremos na próxima etapa; caso contrário, o acesso pode ser imediato.',
      continuePhone: 'Continuar',
      sendPin: 'Enviar PIN',
      signIn: 'Entrar',
      otpHint: 'Digite o PIN que você recebeu.',
      changeNumber: 'Usar outro número',
      backToEmail: 'Entrar com email',
      countrySearch: 'Digite o nome do país',
      countryPickerTitle: 'Escolher país',
      closeCountryPicker: 'Fechar',
      placeholder: {
        nationalNumber: 'Telefone',
        pin: 'Código PIN'
      },
      error: {
        nationalNumber: 'Informe um telefone válido.',
        pin: 'Digite o PIN que enviamos.',
        invalidRequest: 'Verifique o número e tente novamente.',
        notFound: 'Não foi possível enviar o PIN para este número.',
        generic: 'Algo deu errado. Tente novamente.'
      }
    },
    viuCallback: {
      signingIn: 'Entrando…',
      errorTitle: 'Não foi possível concluir a verificação do telefone',
      backHome: 'Continuar para o app',
      invalidHash: 'Não foi possível ler os dados de verificação. Tente novamente ou entre com o telefone.',
      somethingWentWrong: 'Algo deu errado. Tente novamente.'
    },
    viuStatus: {
      invalidCredentials: 'Credenciais inválidas.',
      invalidHash: 'Hash inválido. Não foi possível concluir a verificação.',
      serverError: 'Erro no servidor. Tente novamente mais tarde.',
      requestNotAllowed: 'Esta solicitação não é permitida.',
      heFailure: 'Falha no enriquecimento de cabeçalho.',
      invalidRequestParameters: 'Parâmetros de solicitação inválidos.',
      apiMaintenance: 'Serviço temporariamente indisponível por manutenção.',
      unknown: 'Algo deu errado. Tente novamente.',
      genericFailure: 'Não foi possível concluir a verificação.',
      missingData: 'Os dados de verificação estavam incompletos.',
      missingMsisdn: 'O número de telefone não veio na resposta. Entre com seu telefone.',
      noActiveSubscription:
        'Você não tem uma assinatura ativa. Assine ou entre com seu telefone para continuar.',
      invalidIp: 'Este endereço IP não é permitido.',
      requestTimeout: 'A solicitação expirou. Tente novamente.',
      phoneLoginNoAccount: 'Não encontramos uma conta PlayKids vinculada a este número de telefone.',
      phoneLoginNoSubscription: 'Não encontramos uma assinatura PlayKids vinculada a este número de telefone.',
      phoneLoginInternalError: 'Ocorreu um erro interno.'
    },
    ghanaCallback: {
      signingIn: 'Entrando…',
      dismiss: 'OK',
      pinRequired:
        'Precisamos de um código de verificação para este número. Toque em OK para entrar com o telefone e informar o PIN que enviarmos.',
      pinRequiredTitle: 'Código de verificação necessário',
      invalidMsisdn: 'Não foi possível ler o número no link. Entre com seu telefone.',
      genericError: 'Algo deu errado. Tente entrar com seu telefone.'
    },
    apple: {
      signIn: 'Entrar com Apple',
      signUp: 'Cadastrar com Apple'
    },
    facebook: {
      signIn: 'Entrar com Facebook',
      signUp: 'Cadastrar com Facebook'
    },
    playphone: {
      title: 'Conectar com Playphone',
      subtitle: 'O melhor conteúdo educacional para seus filhos está aqui.',
      placeholder: {
        email: 'Seu email da Playphone'
      },
      signIn: 'Entrar',
      error: {
        email: 'Digite um email válido.',
        generic:
          'Oops! Não conseguimos encontrar nenhuma conta cadastrada com este email.'
      }
    },
    playphoneLastStep: {
      title: 'Último Passo',
      subtitle: 'Digite seu ID de Usuário para logar',
      placeholder: {
        email: 'Seu email da Playphone'
      },
      signIn: 'Entrar',
      forgotUserId: {
        message: 'Esqueceu seu ID de usuário?',
        CTA: 'Clique aqui.'
      },
      error: {
        email: 'Digite um email válido.',
        generic:
          'Oops! Não conseguimos encontrar nenhuma conta cadastrada com este email.'
      }
    },
    forgotPassword: {
      title: 'Esqueceu sua senha?',
      subtitle:
        'Não se preocupe! Nós mandaremos no seu email um link para que você possa redefini-la. :)',
      placeholder: 'Digite seu email da PlayKids',
      send: 'Enviar',
      success:
        'Link enviado para <b>{email}</b><br/>Confira seu email em dentro de alguns instantes.',
      error: {
        email: 'Digite um email válido.',
        generic:
          'Oops! Não conseguimos enviar o link para este email.\nConfira o endereço preenchido e tente novamente.'
      }
    },
    signUp: {
      hero: {
        title: 'Assine aqui, divirta-se onde quiser!',
        content:
          'Com a sua assinatura, você acessa o PlayKids no smartphone, no computador ou na Smartv. Assim, a diversão e o conhecimento nunca saem de perto da sua família.'
      },
      title: 'Cadastre-se na PlayKids!',
      subtitle:
        'Não se preocupe, seus dados serão utilizados com segurança apenas pelo PlayKids e para garantir uma experiência completa.',
      placeholder: {
        email: 'E-mail do responsável',
        password: 'Crie uma senha',
        cpf: 'Digite seu CPF',
        code: 'Digite seu código do cliente'
      },
      signUp: 'Cadastrar',
      signUpMethodsSeparator: 'Ou',
      methods: {
        facebook: 'Para facilitar, você pode criar sua conta usando o Facebook',
        partner:
          'Você está vindo por algum parceiro PlayKids? Então Clique aqui',
        partnerCta: 'Continuar via parceiro'
      },
      partners: {
        title: 'Continuar via parceiro',
        sky: {
          text: 'Continue seu cadastro usando os dados da sua TV SKY',
          cta: 'Continuar via TV sky'
        },
        playphone: {
          text: 'Continue seu cadastro usando os seus dados do Provedor de Internet',
          cta: 'Continuar via provedor de internet'
        }
      },
      signIn: {
        message: 'Já tem uma conta?',
        CTA: 'Clique aqui para entrar'
      },
      error: {
        email: 'Digite um email válido.',
        password:
          'A senha deve ter entre 8 e 30 caracteres (letras e números).',
        emailAlreadyExists: {
          message:
            'Já encontramos uma conta PlayKids cadastrada neste email.<br/>Você gostaria de ',
          CTA: 'entrar?'
        },
        invalidRequest: 'Tem algo errado com os dados fornecidos.',
        generic: 'Algum erro aconteceu.',
        ifoodEmail: 'Digite um email iFood válido.'
      }
    },
    resetPassword: {
      title: 'Redefina sua Senha',
      subtitle: 'Uma boa senha deve ser forte, mas também memorável.',
      placeholder: {
        password: 'Digite sua nova senha',
        confirmPassword: 'Confirme sua nova senha'
      },
      reset: 'Redefinir Senha',
      success: 'Senha alterada com sucesso!',
      error: {
        password: 'A senha deve ter no mínimo 8 caracteres (letras e números).',
        passwordsDontMatch: 'As senhas não coincidem!',
        invalidRequest: 'Erro ao tentar criar a senha',
        expiredToken: {
          message: 'Seu link expirou, tente',
          CTA: 'reenviá-lo.'
        },
        generic: 'Algum erro aconteceu.'
      }
    },
    emailOnly: {
      title: 'Comece já a unir<br/>aprendizado e diversão',
      subtitle: 'Acesse sua conta ou crie uma nova.',
      access: 'Acessar',
      signInMethodsSeparator: 'OU',
      placeholder: {
        email: 'Digite seu e-mail'
      },
      playphoneRouter: 'Conectar com Playphone',
      error: {
        email: 'Digite um email válido.',
        invalidRequest: 'Tem algo errado com os dados fornecidos.',
        generic: 'Algum erro aconteceu.'
      }
    },
    passwordOnly: {
      title: 'Você já possui uma conta!',
      subtitle: 'Precisamos da sua senha para continuar.',
      placeholder: {
        password: 'Digite sua senha'
      },
      forgotPassword: 'Esqueci minha senha',
      signIn: 'Entrar',
      error: {
        password: 'A senha deve ter no mínimo 8 caracteres (letras e números).',
        invalidRequest: 'Tem algo errado com os dados fornecidos.',
        wrongCredentials:
          'Email não cadastrado ou senha incorreta.\nPor favor, tente novamente.',
        generic: 'Algum erro aconteceu.'
      }
    }
  },
  common: {
    format: {
      date: 'DD/MM/YYYY',
      dateRaw: 'DDMMYYYY'
    }
  },
  policies: {
    privacy: 'Ao usar os serviços da Playkids, você concorda com nossa',
    privacyTitle: 'Política de Privacidade',
    privacyLink: 'https://policies.playkids.com/pt/privacy',
    tos: 'Ao usar os serviços da Playkids, você concorda com nossos',
    tosTitle: 'Termos de Uso',
    tosLink: 'https://policies.playkids.com/pt/tos'
  },
  checkout: {
    registerKid: {
      title: 'Para cada criança, <br />uma experiência diferente',
      description:
        'Preenchendo os dados, você garante que o conteúdo adequado para a faixa etária da criança esteja ao alcance dela.',
      form: {
        title: 'Legal! Vamos criar um novo perfil.',
        description:
          'Com o perfil, a criança terá acesso ao conteúdo mais adequado para ela!',
        inputName: 'Nome da Criança',
        inputBirthDate: 'Data de Nascimento',
        cancelButtonLabel: 'Cancelar',
        saveButtonLabel: 'Criar perfil',
        updateButtonLabel: 'Salvar alteração',
        successCreateMessage: 'O perfil de {name} foi criado.',
        successUpdateMessage: 'O perfil de {name} foi alterado.',
        successDeleteMessage: 'O perfil de {name} foi removido.',
        errorCreateMessage: 'Ocorreu um erro ao criar o perfil de {name}.',
        errorUpdateMessage: 'Ocorreu um erro ao editar o perfil de {name}.',
        errorDeleteMessage: 'Ocorreu um erro ao remover o perfil de {name}.',
        errorCardInfo: 'Ocorreu um erro verifique os dados do cartão.'
      },
      list: {
        buttonLabel: 'Criar novo perfil',
        card: {
          name: 'Nome da Criança',
          birthDate: 'Data de Nascimento',
          editButton: 'Editar dados'
        }
      },
      removeModal: {
        title: 'Tem certeza que deseja excluir o perfil de',
        cancelButton: 'Cancelar',
        removeButton: 'Excluir perfil'
      }
    },
    planSelector: {
      title: 'O melhor vai começar agora!',
      loading: 'Carregando planos...',
      description:
        'Escolha o seu plano e embarque nessa viagem cheia de diversão e conhecimento.',
      planBox: {
        month: 'mês',
        months: 'meses',
        priceLabel: {
          month: 'por mês',
          year: 'Em 1x'
        },
        priceDetails: 'Neste plano o valor mensal sai por',
        paymentDetails: 'cobrado uma vez.'
      }
    },
    payment: {
      navTabs: {
        itemCard: 'Pagar com cartão',
        itemCoupon: 'Pagar com cupom'
      },
      cardTab: {
        title: 'Preencha os seus dados',
        description:
          'Estamos chegando cada vez mais perto do Mundo PlayKids! Insira seus dados para o cadastro e o seu cartão de crédito.',
        planDetails:
          'Você terá um mês de presente para explorar o Mundo PlayKids. A cobrança no valor de {planPrice} só será feita após o fim dos 30 dias. Você pode cancelar antes do final do teste.',
        form: {
          personalSection: {
            title: 'Dados pessoais',
            documentLabel: 'CPF',
            addressLabel: 'Endereço',
            addressZipCodeLabel: 'CEP',
            addressDistrictLabel: 'Bairro',
            addressNumberLabel: 'Número',
            addressComplementLabel: 'Complemento',
            addressCityLabel: 'Cidade',
            addressStateLabel: 'Estado'
          },
          paymentSection: {
            title: 'Dados de Pagamento',
            documentLabel: 'CPF',
            emailLabel: 'E-mail',
            cardNumberLabel: 'Número do cartão',
            cardHolderNameLabel: 'Nome impresso no cartão',
            cardExpirationMonthLabel: 'Mês',
            cardExpirationYearLabel: 'Ano'
          }
        }
      },
      couponTab: {
        title: 'Preencha os dados do seu cupom',
        description:
          'Estamos chegando cada vez mais perto do Mundo PlayKids! Insira seu cupom par finalizar o cadastro.',
        form: {
          couponLabel: 'Insira seu cupom',
          couponInput: 'Cupom de desconto'
        }
      }
    },
    checkoutPaymentSucceeded: {
      title: 'Olá, como é bom ter você aqui com a gente.',
      subtitle: 'Antes de mais nada, a sua assinatura está confirmada!',
      description:
        'Agora as crianças vão poder aproveitar o universo PlayKids acessando todos os nosso conteúdos via smartphones, tablets, computadores e até Smart TVs! <br /><br /><strong>É PlayKids em todo lugar!</strong><br /><br /> Para acessar PlayKids em outros dispositivos é só procurar o APP na loja do seu aparelho e fazer o login com a sua conta PlayKids!',
      finish: 'Começar'
    }
  },
  account: {
    credentials: {
      title: 'Dados da conta',
      facebook: {
        title: 'Seu login é via Facebook',
        text: 'Nós nunca postaremos nada em sua conta nem enviaremos mensagens para seus contatos'
      }
    },
    status: {
      subscription: {
        type: {
          title: 'Tipo de assinatura',
          values: {
            SEMESTERLY: 'Semestral',
            YEARLY: 'Anual'
          }
        },
        status: {
          title: 'Status da assinatura',
          values: {
            ACTIVE: 'Ativa'
          }
        },
        expiration: {
          title: 'Vencimento'
        },
        cancelCta: 'Cancelar assinatura'
      }
    },
    payments: {
      title: 'Pagamentos',
      datePayment: 'Sua próxima cobrança será em: ',
      dateCancellation: 'Assinatura expirará em: ',
      howToChange: 'Como alterar a assinatura'
    },
    changeEmail: {
      title: 'Alterar e-mail',
      emailPlaceholder: 'Digite seu novo endereço de e-mail',
      passwordPlaceholder: 'Digite sua senha atual',
      errors: {
        403: 'Senha incorreta',
        409: 'Esse e-mail já está sendo utilizado',
        same: 'Esse e-mail já é utilizado por você'
      },
      cancel: 'Cancelar',
      cta: 'Alterar e-mail',
      success: 'E-mail alterado'
    },
    changePassword: {
      title: 'Alterar senha',
      placeholders: {
        current: 'Digite sua senha atual',
        new: 'Digite sua nova senha (min. 8 caracteres)',
        confirm: 'Confirme sua nova senha'
      },
      errors: {
        403: 'A senha atual está incorreta',
        generic: 'Ops, não conseguimos cadastrar sua nova senha'
      },
      success: 'Senha alterada com sucesso!',
      cta: 'Alterar senha'
    },
    cancelSubscription: {
      title: 'Tem certeza que deseja cancelar sua assinatura?',
      textDate:
        'Cancelando agora você terá acesso ao conteúdo até [DATE]. Você pode voltar a assinar a qualquer momento.',
      textFooter: 'PlayKids será sempre um ambiente seguro e educativo.',
      errorLine: 'Não foi possível cancelar sua assinatura.',
      cancel: 'Voltar',
      cta: 'Cancelar assinatura',
      modalCta: 'Quero cancelar',
      success: {
        title: 'Cancelamento realizado com sucesso',
        text1:
          'Esperamos que seu pequeno tenha aprendido e se divertido muito enquanto estivemos juntos.',
        text2:
          'Por último, poderia responder uma pesquisa bem rápida para nos ajudar?',
        formCta: 'Responder pesquisa'
      }
    }
  },
  misc: {
    backButtonText: 'Voltar',
    developmentTagsTitle: 'Eixos de Desenvolvimento',
    logoutButtonText: 'Sair',
    season: '{n} Temporada | {n} Temporadas',
    episodes: 'Episódios',
    ageAdvise:
      'Todo show no PlayKids é apropriado para todas as idades, mas alguns temas são melhor compreendidos em estágios específicos do desenvolvimento do pequeno.',
    termsOfUse: {
      text: 'Termos de Uso',
      url: 'https://cdn.pkds.it/policy/ios/tos-pt.html'
    },
    privacyPolicy: {
      text: 'Política de Privacidade',
      url: 'https://cdn.pkds.it/policy/ios/privacy-pt.html'
    },
    creditCard: {
      securityCodeLabel: 'Código de <br />segurança',
      expiration: {
        month: 'MM',
        year: 'AAAA'
      }
    }
  },
  inactive: {
    message:
      'Aparentemente, você não tem uma assinatura PlayKids ativa, então você não pode acessar nosso conteúdo <span>:(</span>'
  },
  downloadAppBanner: {
    title: 'Baixe o PlayKids app!',
    text: 'Vídeos, livros e jogos para aprender se divertindo!',
    CTA: 'Baixar'
  },
  demo: {
    badge: 'versão demo',
    dialog: {
      text: 'Quer acesso ao conteúdo completo?',
      CTA: 'Assine agora!'
    }
  },
  header: {
    message: 'Já possui uma conta?',
    button: 'Entrar'
  },
  menu: {
    account: 'Conta',
    support: 'Ajuda',
    logout: 'Sair'
  },
  footer: {
    title: 'Está com dúvidas?',
    links: {
      questions: {
        title: 'Central de Ajuda',
        url: 'https://help.playkids.com'
      },
      termsOfUse: {
        title: 'Termos de uso',
        url: 'https://policies.playkids.com/pt/tos'
      },
      privacyPolicy: {
        title: 'Política de Privacidade',
        url: 'https://policies.playkids.com/pt/privacy'
      },
      informationSecurityPolicy: {
        title: 'Política de Segurança da Informação',
        url: 'https://policies.playkids.com/pt/security'
      },
      cookiePolicy: {
        title: 'Política de Cookies',
        url: 'https://policies.playkids.com/pt/cookie'
      }
    }
  },
  partnerships: {
    form: {
      authenticated: {
        title:
          'Insira os dados da sua conta para terminarmos de criar seu acesso',
        inputEmail: 'Digite o email da sua conta PlayKids',
        inputCode: 'Digite seu código de cliente',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      },
      signIn: {
        inputEmail: 'Digite o email da sua conta PlayKids',
        inputPassword: 'Digite sua senha de acesso',
        cta: 'Entrar'
      },
      signInOption: {
        title: 'Já tem uma conta PlayKids?',
        cta: 'Clique aqui para entrar'
      },
      signUpOption: {
        title: 'Não tem uma conta PlayKids?',
        cta: 'Cadastrar-se'
      },
      signUp: {
        inputEmail: 'Digite o email para a sua conta PlayKids',
        inputConfirmEmail: 'Confirme o email da sua conta PlayKids',
        inputPassword: 'Crie sua senha de acesso',
        inputConfirmPassword: 'Confirme a senha inserida',
        inputPasswordHint:
          'A senha deve ter entre 8 e 30 caracteres (letras e números).',
        cta: 'Criar conta PlayKids'
      },
      success: {
        title: 'Legal! Seu cadastro foi concluido com sucesso!',
        description:
          'Agora as crianças vão poder aproveitar o universo PlayKids acessando todos os nosso conteúdos via Smartphones, tablets, computadores e ate SmartTV!',
        subtitle: 'É PlayKids em todo lugar!',
        stores:
          'Para acessar PlayKids em outros dispositivos é só procurar o APP na loja de seu aparelho e fazer o login com a sua conta PlayKids.',
        signInTitle: 'Legal! Agora vamos associar sua conta PlayKids.',
        signInAuthenticatedTitle: 'Legal! Sua conta foi acessada com sucesso.',
        authenticatedDescription:
          'Para finalizar o resgate do seu benefício, clique no botão de resgate ou em cancelar pra não resgatar agora.',
        signInDescription:
          'Informe o email e senha que você já utiliza para acessar os aplicativos da PlayKids',
        signUpTitle: 'Legal! Vamos criar uma conta PlayKids.',
        signUpAuthenticatedTitle: 'Legal! Sua conta foi criada com sucesso.',
        signUpDescription:
          'Primeiro precisamos que você nos informe o email e a senha que você irá usar para acessar os aplicativos da PlayKids',
        signUpDescriptionPlayHub:
          'Agora precisamos que você nos informe o e-mail e a senha que você irá usar para acessar os aplicativos da PlayKids.'
      },
      errors: {
        inputEmail: 'Digite um e-mail válido.',
        inputPassword: 'Digite uma senha válida.',
        inputCode: 'Digite um código de cliente válido.',
        wrongCredentials:
          'Email não cadastrado ou senha incorreta.<br />Por favor, tente novamente.',
        inputConfirmEmail: 'Os e-mails não conferem!',
        inputConfirmPassword: 'As senhas não conferem!',
        emailAlreadyExists:
          'Já encontramos uma conta PlayKids cadastrada neste email',
        generic:
          'Ops! Algo não funcionou como esperávamos enquanto validávamos seu cadastro.<br />Por favor, tente novamente mais tarde.'
      },
      playhub: {
        validation: {
          internetProvider: 'Informe o nome do seu Provedor de Internet',
          headerTitle: 'Vamos validar sua conta!',
          headerDescription:
            'Preencha as informações abaixo com seus dados do Provedor de Internet para liberar a criação da sua conta.',
          inputUser: 'Informe seu usuário',
          inputPassword: 'Informe a senha fornecida pelo seu Provedor',
          validationButton: 'Validar'
        }
      }
    },
    playhub: {
      validation: {
        haederTitle: 'Vamos validar sua conta PlayHub!',
        headerDescription:
          'Preencha as informações abaixo com seus dados PlayHub para liberar a criação da sua conta.',
        validationButton: 'Validar'
      }
    }
  },
  tags: {
    body_expression: 'Expressão Corporal',
    directions: 'Direções',
    spatial_orientation: 'Orientação Espacial',
    temporal_orientation: 'Orientação Temporal',
    sports_and_activities: 'Esportes e Atividades',
    drawing: 'Desenho',
    painting: 'Pintura',
    writing: 'Escrita',
    handmade_activities: 'Atividades Manuais',
    balance: 'Equilíbrio',
    vocabulary_and_words: 'Vocabulário e Palavras',
    image_interpretation: 'Interpretação Imagética',
    phonemes_and_alphabet: 'Fonemas e Alfabeto',
    colors: 'Cores',
    sounds_and_sound_sources: 'Sons e Fontes Sonoras',
    artistic_language: 'Linguagem Artística',
    reading_and_fluency: 'Leitura e Fluência',
    grammar: 'Gramática',
    genres_and_textual_types: 'Gêneros e Tipos Textuais',
    fantasy_and_imagination: 'Fantasia e Imaginação',
    musical_scale_and_styles: 'Escala e Estilos Musicais',
    musical_instruments: 'Instrumentos Musicais',
    artistic_expression: 'Expressão Artística',
    language: 'Idiomas',
    songs_and_rhymes: 'Canções e Ritmos',
    symbols: 'Símbolos',
    numbers: 'Números',
    shapes: 'Formas',
    counting: 'Contagem',
    sorting: 'Ordenação',
    measurement: 'Medidas',
    comparison: 'Comparação',
    capacity: 'Capacidade',
    series_and_sequences: 'Seriação e Sequenciamento',
    values: 'Dinheiro e Valores',
    charts_and_tables: 'Gráficos e Tabelas',
    quantities: 'Quantidade',
    finance: 'Finanças',
    operations: 'Operações Matemáticas',
    biology_and_life: 'Biologia e vida',
    fauna_and_flora: 'Fauna e Flora',
    geography_and_phenomena: 'Geografia e fenômenos',
    outer_space: 'Espaço Sideral',
    physics: 'Física',
    chemistry: 'Química',
    body_and_health: 'Corpo e Saúde',
    foods: 'Comidas',
    senses_and_sensations: 'Sentidos e Sensações',
    auditory_attention: 'Atenção Auditiva',
    temporal_perception: 'Percepção Temporal',
    spatial_perception: 'Percepção Espacial',
    shape_perception: 'Percepção de Figuras e Formas',
    memory: 'Memória',
    attention: 'Atenção',
    concentration: 'Concentração',
    problem_solving: 'Resolução de Problemas',
    logic: 'Lógica',
    empirical_knowledge: 'Conhecimento empírico',
    decision_making: 'Tomada de Decisão',
    games_and_toys: 'Jogos e Brinquedos',
    family: 'Família',
    citizenship_and_ethics: 'Cidadania e Ética',
    holidays_and_celebrations: 'Feriados e Celebrações',
    cultures_and_mores: 'Costumes e Cultura',
    work_and_occupation: 'Trabalhos e Profissões',
    history: 'História',
    places_and_landscapes: 'Lugares e Paisagens',
    transport: 'Meios de Transporte',
    media: 'Mídia',
    objects_and_transformations: 'Objetos e Transformações',
    sustainability: 'Sustentabilidade',
    tech: 'Tecnologia',
    safety: 'Segurança',
    collectivity: 'Coletividade',
    empathy: 'Empatia',
    social_participation: 'Participação Social',
    respect_and_tolerance: 'Respeito e Tolerância',
    equality: 'Igualdade',
    justice: 'Justiça',
    relationships: 'Construção de Relacionamentos',
    duties_and_rights: 'Direitos e Deveres',
    physical_characteristics: 'Características Físicas',
    feelings_and_emotions: 'Sentimentos e Emoções',
    fear_and_frustration: 'Medo e Frustração',
    habits_and_routine: 'Hábitos e Rotina',
    clothing: 'Roupas',
    hygiene_and_welfare: 'Higiene e Bem-estar',
    behavior: 'Comportamento',
    needs: 'Necessidades',
    genres: 'Gêneros',
    protagonism: 'Protagonismo',
    creativity: 'Criatividade',
    autonomy: 'Autonomia',
    self_control_and_resilience: 'Autocontrole e Resiliência',
    graphic_language: 'Linguagem Gráfica',
    images_and_shapes: 'Imagens e Formas',
    idioms: 'Idiomas',
    food_and_alimentation: 'Alimentação',
    chemistry_and_physics: 'Química e Física',
    environment: 'Meio Ambiente',
    people_and_family: 'Pessoas do Convívio e Família',
    team_work: 'Trabalho em equipe',
    food: 'Comida',
    self_control: 'Autocontrole',
    biology: 'Biologia',
    flora: 'Plantas',
    animals: 'Animais',
    how_stuff_is_made: 'Como os objetos são feitos',
    how_stuff_works: 'Como os objetos funcionam',
    resilience: 'Resiliência',
    natural_phenomena: 'Fenômenos Naturais',
    places_and_landmarks: 'Lugares e pontos de referência',
    human_body: 'Corpo Humano',
    geography: 'Geografia',
    digital_citizenship: 'Cidadania Digital',
    digital_literacy: 'Alfabetização Digital',
    cancel: 'Cancelar'
  }
}
